import React, { useState, useEffect } from "react";
// BrowserRouter: таза URL (/analytics, /#/analytics емес).
// ps.kz (Plesk nginx) SPA-fallback бермейді, сондықтан `npm run build`-тан
// кейін scripts/spa-fallback.js әр маршрутқа build/<path>/index.html
// көшірмесін жасайды — F5 / тікелей сілтеме 404 бермейді.
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import "./App.css";
import "./styles/dark-theme.css";
import "./styles/light-theme.css";
import "./components/Input.css";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import getRole from "./api/getRole";
import SignIn from "./components/SignIn";
import AdminDashboard from "./components/AdminDashboard";
import ModeratorDashboard from "./components/ModeratorDashboard";
import OperatorDashboardNew from "./components/OperatorDashboardNew";
import SalesManagerDashboard from "./components/SalesManager";
import FinansAgroDashboard from "./components/FinansAgroDashboard";
import ServerModeToggle from "./components/ServerModeToggle";

const App = () => {
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkExistingSession = async () => {
      const token = localStorage.getItem("google_id_token");

      if (token) {
        try {
          const role = await getRole();
          setUserRole(role);
          setIsSignedIn(true);
        } catch (error) {
          console.error("Error fetching role:", error);
          localStorage.removeItem("google_id_token");
        }
      }
      setLoading(false);
    };

    checkExistingSession();
  }, []);

  const handleSignIn = async () => {
    setIsSignedIn(true);
    setLoading(true);

    try {
      const role = await getRole();
      setUserRole(role);
    } catch (error) {
      console.error("Error fetching role:", error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="dark-theme flex items-center justify-center min-h-screen bg-gray-900">
        <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  return (
    <ThemeProvider>
      <LanguageProvider>
      <Router>
        <div className="App">
          {/* Кірмеген кезде де көрінеді (қай серверге кіру керектігін көрсету үшін).
              Админ мен модераторда — тақырып жолағында (қалқымалысы «Выйти»-ді жабатын). */}
          {(!isSignedIn || !["admin", "moderator"].includes(userRole)) && <ServerModeToggle />}
          {!isSignedIn ? (
            <SignIn onSignIn={handleSignIn} />
          ) : (
            <Routes>
              {userRole === "admin" && <Route path="/*" element={<AdminDashboard />} />}
              {userRole === "moderator" && <Route path="/" element={<ModeratorDashboard />} />}
              {(userRole === "operator" || userRole === "support") && (
                <Route path="/" element={<OperatorDashboardNew />} />
              )}
              {userRole === "sales_manager" && <Route path="/" element={<SalesManagerDashboard />} />}
              {userRole === "finans_agro" && <Route path="/" element={<FinansAgroDashboard />} />}
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          )}
        </div>
      </Router>
      </LanguageProvider>
    </ThemeProvider>
  );
};

export default App;